import { useCallback, useRef } from 'react'

import { BottomSheetModal } from '@gorhom/bottom-sheet'

export const useCompletedChapterSheet = () => {
  const completedChapterSheetRef = useRef<BottomSheetModal>(null)

  const openBottomModal = useCallback(() => {
    completedChapterSheetRef.current?.present()
  }, [])

  const closeBottomModal = useCallback(() => {
    completedChapterSheetRef.current?.close()
  }, [completedChapterSheetRef])

  const handleCompletedChapterSheet = () => openBottomModal()

  return {
    completedChapterSheetRef,
    closeBottomModal,
    handleCompletedChapterSheet
  }
}
